<div class="dialogue-content">
  <div class="mat-dialogue-header">
    <h4>Add Order</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
  <mat-dialog-content class="">
    <div class="row">
      <div class="col-lg-12 col-12">
        <div class="mb-3">
          <mat-label>Select Customer<span>*</span></mat-label>
          <mat-form-field class="w-100 select-customer">
            <mat-select id="style" placeholder="Select Customer" [(ngModel)]="selectedCustomerId" #singleSelect
              (selectionChange)="fetchSelectedCustomerData()">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Customer..."
                  noEntriesFoundLabel="No such customer found." [formControl]="customerCtrl"></ngx-mat-select-search>
              </mat-option>
              <mat-option panelClass="search-top" *ngFor="let customer of filteredCustomer | async"
                [value]="customer.customerId" matTooltip="{{ customer.email }}" matTooltipPosition="above">
                <div class="custom-option d-flex align-items-center justify-content-between w-100 gap-2">
                  <div class="d-flex align-items-center justify-content-start gap-1 flex-nowrap">
                    <img [src]="customer.images" (error)="customerDropdownImageHandler(customer)"
                      class="img-fluid profile-pic-table me-2" width="40px" alt="Not found">
                    <p class="text-left mb-0 WrapData">{{customer.customerName}} </p>
                  </div>
                  <p class="text-left mb-0 WrapData">{{customer.customerAddress}}</p>
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div
      class="d-flex align-items-center justify-content-sm-end justify-content-center flex-wrap flex-md-nowrap row-gap-2">
      <span class="tool-tip me-2" data-toggle="tooltip" data-placement="top"
        [title]=" selectedCustomerData?.isPassBuy == true ? 'Selected customer has already pass purchased' : 'Add Session'">
        <button class="btn btn-primary" (click)="addSession()"
          [disabled]="selectedCustomerData?.isPassBuy || selectedCustomerId == null">
          <i class="fa-solid fa-plus me-1"></i>Add Session
        </button>
      </span>
      <span class="tool-tip me-2" data-toggle="tooltip" data-placement="top" title="Add Event">
        <button class="btn btn-primary" (click)="addEvent()" [disabled]="selectedCustomerId == null">
          <i class="fa-solid fa-plus me-1"></i>Add Event
        </button>
      </span>
    </div>
    <div class="mt-3 selectedCustomer">
      <div *ngIf="selectedCustomerData && selectedCustomerData !=[]" class="p-2">
        <div class="row selected-custome-details px-4 py-3  ">
          <div class="col-md-7 col-sm-12">
            <div class="d-flex align-items-center justify-content-start gap-1 mb-2 flex-wrap">
              <img [src]="selectedCustomerData.images" (error)="customerImageHandler()"
                class="img-fluid profile-pic-table me-2" width="40px" alt="Not found">
              <p class="mb-0 customer-name">{{selectedCustomerData.firstName}} {{selectedCustomerData.lastName}}</p>
            </div>
            <div class="customer-info">
              Email : <span>{{selectedCustomerData.email}}</span>
            </div>
            <div class="customer-info">
              Phone : <span>{{selectedCustomerData.phoneNumber}}</span>
            </div>
            <div class="customer-info">
              Address : <span>{{selectedCustomerData.fullAddress}}</span>
            </div>
          </div>
          <div class="col-md-5 col-sm-12">
            <div class="customer-info">
              Order Date : <span [innerHTML]="currentDay | ordinalDate : currentDay"></span>
            </div>
            <div class="customer-info">
              Order Time : <span>{{currentDay | date: dateFormat.shortTime}}</span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="selectedCustomerData== null" class="select-customer-message">
        Select customer from above
      </div>
    </div>
  </mat-dialog-content>
</div>